import React from "react";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="ozia-footer">
      <div className="ozia-footer-container">

        <div className="ozia-footer-top">

          {/* Brand */}
          <div className="ozia-footer-brand">
            <img src="/favicon-510.png" alt="OZIA AI Logo" />
            <h2>OZIA AI</h2>
            <p>
              OZIA AI is an intelligent assistant designed to help people
              think, create, learn and build faster using advanced AI
              technology — secure, adaptive and human-centric.
            </p>
          </div>

          {/* Columns */}
          <div className="ozia-footer-columns">

            <div className="ozia-footer-col">
              <h4>Product</h4>
              <a href="/features">Features</a>
              <a href="/pricing">Pricing</a>
              <a href="/payments">Payments</a>
              <a href="/updates">Updates</a>
            </div>

            <div className="ozia-footer-col">
              <h4>Resources</h4>
              <a href="/docs">Documentation</a>
              <a href="/api">API Access</a>
              <a href="/community">Community</a>
              <a href="/support">Support</a>
            </div>

            <div className="ozia-footer-col">
              <h4>Company</h4>
              <a href="/about">About OZIA</a>
              <a href="/careers">Careers</a>
              <a href="/contact">Contact</a>
              <a href="/partners">Partners</a>
            </div>

            <div className="ozia-footer-col">
              <h4>Legal</h4>
              <a href="/privacy">Privacy Policy</a>
              <a href="/terms">Terms of Service</a>
              <a href="/security">Security</a>
              <a href="/compliance">Compliance</a>
            </div>

          </div>

        </div>

        <div className="ozia-footer-divider"></div>

        {/* Bottom */}
        <div className="ozia-footer-bottom">

          <p className="ozia-footer-copyright">
            From <a href="https://ozia.netlify.app/" className="ozia-link">OZIA</a> © {year} OZIA AI. All rights reserved.
          </p>

          <div className="ozia-footer-socials">
  {/* GitHub */}
  <a href="https://github.com/Ayubu" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
    <i className="fab fa-github"></i>
  </a>

  {/* X (formerly Twitter) - Updated icon class */}
  <a href="https://x.com/KabuyeA26638" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
    <i className="fab fa-x-twitter"></i>
  </a>

  {/* LinkedIn */}
  <a href="https://www.linkedin.com/in/_ayubu._" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
    <i className="fab fa-linkedin-in"></i>
  </a>

  {/* Dribbble - Fixed prefix and spelling */}
  <a href="https://dribbble.com/kabuye-ayubu" target="_blank" rel="noopener noreferrer" aria-label="Dribbble">
    <i className="fab fa-dribbble"></i>
  </a>

  {/* Instagram */}
  <a href="https://www.instagram.com/_.ayubu._" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
    <i className="fab fa-instagram"></i>
  </a>

  {/* Facebook */}
  <a href="https://www.facebook.com/Ayubu.01" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
    <i className="fab fa-facebook-f"></i>
  </a>
          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;